const MAX_ATTEMPTS = 4;
const BASE_DELAY_MS = 600;
const REQUEST_TIMEOUT_MS = 120000;

function shouldRetry(status) {
  if (status === 0 || status === 408 || status === 429) return true;
  if (status >= 500) return true;
  return false;
}

function nextDelay(attempt) {
  const jitter = Math.random() * 0.3 + 0.85;
  return Math.round(BASE_DELAY_MS * Math.pow(2, attempt - 1) * jitter);
}

function waitForOnline(callback) {
  if (navigator.onLine) {
    callback();
    return;
  }

  const onOnline = () => {
    window.removeEventListener("online", onOnline);
    callback();
  };

  window.addEventListener("online", onOnline);
}

function uploadWithRetry(entry, onViewError, attempt = 1) {
  const { url, headers, key } = entry.meta || {};
  if (!url) {
    const msg = "Missing presigned URL in entry.meta";
    console.error("[TigrisUploader]", msg, entry.meta);
    entry.error(msg);
    return;
  }

  if (!navigator.onLine) {
    console.warn("[TigrisUploader] Offline, waiting to retry", entry.file?.name);
    waitForOnline(() => uploadWithRetry(entry, onViewError, attempt));
    return;
  }

  console.log(`[TigrisUploader] Upload attempt ${attempt} for`, entry.file?.name, "to", key || "(no key)");

  const xhr = new XMLHttpRequest();

  onViewError(() => xhr.abort());

  xhr.timeout = REQUEST_TIMEOUT_MS;

  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      entry.progress(100);
    } else if (attempt < MAX_ATTEMPTS && shouldRetry(xhr.status)) {
      const delay = nextDelay(attempt);
      console.warn(`[TigrisUploader] Retry ${attempt + 1} in ${delay}ms`, entry.file?.name);
      setTimeout(() => uploadWithRetry(entry, onViewError, attempt + 1), delay);
    } else {
      const message = `Upload failed: ${xhr.status} ${xhr.statusText}`;
      console.error("[TigrisUploader]", message);
      entry.error(message);
    }
  };

  xhr.onerror = () => {
    if (attempt < MAX_ATTEMPTS) {
      const delay = nextDelay(attempt);
      console.warn(`[TigrisUploader] Network error, retry ${attempt + 1} in ${delay}ms`, entry.file?.name);
      setTimeout(() => uploadWithRetry(entry, onViewError, attempt + 1), delay);
    } else {
      const message = "Network error during upload";
      console.error("[TigrisUploader]", message);
      entry.error(message);
    }
  };

  xhr.onabort = () => {
    const message = "Upload aborted";
    console.warn("[TigrisUploader]", message, entry.file?.name);
    entry.error(message);
  };

  xhr.ontimeout = () => {
    if (attempt < MAX_ATTEMPTS) {
      const delay = nextDelay(attempt);
      console.warn(`[TigrisUploader] Timeout, retry ${attempt + 1} in ${delay}ms`, entry.file?.name);
      setTimeout(() => uploadWithRetry(entry, onViewError, attempt + 1), delay);
    } else {
      const message = "Upload timed out";
      console.error("[TigrisUploader]", message);
      entry.error(message);
    }
  };

  xhr.upload.addEventListener("progress", (event) => {
    if (event.lengthComputable) {
      const percent = Math.round((event.loaded / event.total) * 100);
      if (percent < 100) entry.progress(percent);
    }
  });

  xhr.open("PUT", url, true);

  if (headers) {
    Object.entries(headers).forEach(([name, value]) => xhr.setRequestHeader(name, value));
  }

  xhr.send(entry.file);
}

export default function TigrisUploader(entries, onViewError) {
  console.log("[TigrisUploader] Starting upload for", entries.length, "files");

  entries.forEach((entry) => {
    uploadWithRetry(entry, onViewError, 1);
  });
}
